/**
 * Drizzle ORM Web Driver powered by IndexedDB (idb)
 * Supports DB Version 2 with 4 Stores: customers, customer_notes, illustrations, contracts
 */
import { openDB, type IDBPDatabase } from 'idb';
import { drizzle } from 'drizzle-orm/sqlite-proxy';
import * as schema from './schema';

export const DB_NAME = 'equote_local_db';
export const DB_VERSION = 2;

export const STORES = {
  CUSTOMERS: 'customers',
  NOTES: 'customer_notes',
  ILLUSTRATIONS: 'illustrations',
  CONTRACTS: 'contracts',
} as const;

let dbInstancePromise: Promise<IDBPDatabase> | null = null;

export function getIndexedDb(): Promise<IDBPDatabase> {
  if (!dbInstancePromise) {
    dbInstancePromise = openDB(DB_NAME, DB_VERSION, {
      upgrade(db: IDBPDatabase, oldVersion: number) {
        // Version 1: Customers store
        if (!db.objectStoreNames.contains(STORES.CUSTOMERS)) {
          const custStore = db.createObjectStore(STORES.CUSTOMERS, { keyPath: 'id' });
          custStore.createIndex('by_name', 'name');
          custStore.createIndex('by_category', 'category');
          custStore.createIndex('by_phone', 'phone');
        }

        // Version 2: Notes, Illustrations, Contracts stores
        if (!db.objectStoreNames.contains(STORES.NOTES)) {
          const notesStore = db.createObjectStore(STORES.NOTES, { keyPath: 'id' });
          notesStore.createIndex('by_customer_id', 'customerId');
        }

        if (!db.objectStoreNames.contains(STORES.ILLUSTRATIONS)) {
          const illStore = db.createObjectStore(STORES.ILLUSTRATIONS, { keyPath: 'id' });
          illStore.createIndex('by_customer_id', 'customerId');
        }

        if (!db.objectStoreNames.contains(STORES.CONTRACTS)) {
          const contractStore = db.createObjectStore(STORES.CONTRACTS, { keyPath: 'id' });
          contractStore.createIndex('by_customer_id', 'customerId');
          contractStore.createIndex('by_contract_number', 'contractNumber');
        }
      },
    });
  }
  return dbInstancePromise!;
}

/**
 * Initialize Drizzle ORM instance with custom IndexedDB callback driver
 */
export const drizzleDb = drizzle(
  async (sql: string, params: any[], method: 'run' | 'all' | 'values' | 'get') => {
    return { rows: [] };
  },
  { schema }
);
